import { UserTypes } from '@shared/enums/user-types.enum';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ClientesService } from '../../services/clientes.service';

import * as _ from 'lodash';
import { State, City, Districts, User } from '@shared/models';

import { Filters } from './carteira-clientes.models'
import { ConsultRequest } from '@shared/utils/consult-request';
import { RequestWithFetchStatus } from '@shared/utils/request-with-fetch-status';
import { FiltersOfConsult } from '@shared/utils/filters-of-consult';
import {ParametrosClientesPorVendedor, RetornoClientesPorVendedor} from '../../services/clientes.interface'
import * as toastr from 'toastr'
import * as moment from 'moment';
import { Utilservice } from '@core/services/util.service';
import { LocationsService } from '@modules/clientes/services/locations.service';
import { UfComboComponent } from '@shared/components/uf-combo/uf-combo.component';
import { Setor, Vendedor } from '@shared/models';
import { VisitasService } from '@modules/visitas/services/visitas.service';

@Component({
  selector: 'app-carteira-clientes',
  templateUrl: './carteira-clientes.component.html',
  styleUrls: ['./carteira-clientes.component.scss']
})
export class CarteiraClientesComponent implements OnInit {
  UserTypes = UserTypes
  userLogado: User;

  citiesRequest = new ConsultRequest<City[]>();
  districtsRequest = new ConsultRequest<Districts[]>()

  vendedoresRequest = new ConsultRequest<Vendedor[]>();

  @Input() vendedorr: {type: string};

  filtersOfConsult = new FiltersOfConsult<Filters>({
    setor: null,
    uf: null,
    cidade: null,
    bairro: '',
    vendedor: null,
    status: -1
  });
  
  lsVendedores: Vendedor[] = [];
  lsStates: State[] = [];
  
  vendedor : Vendedor;
  vendedorLoading : boolean = false;
  vetorSetor: any;
  setorFzs: string;

  private debouncedGetSetor =  _.debounce(()=>this.getIdSetorComc(), 1000, {
    'leading': false,
    'trailing': true
  })


  @ViewChild('ufsVendedor', {static: false}) ufViewChild: UfComboComponent;
  
  constultaRequest = new ConsultRequest<RetornoClientesPorVendedor[]>()
  exportRequest = new RequestWithFetchStatus<any>()

  constructor(
    private clientService: ClientesService,
    private locationsService: LocationsService,
    private visitService: VisitasService,
  ) {
  }

  filtrarUf(){
    if(this.filtersOfConsult.filters.vendedor) {
      this.locationsService.listUFBySectorAndSeller(this.vetorSetor.codigo, this.filtersOfConsult.filters.vendedor.nome).subscribe(
        ufsFiltradas => {
          this.lsStates = ufsFiltradas;
          let sgMap = (ufsFiltradas.map(uf => uf.sgUf));
          this.ufViewChild.ufs = ufsFiltradas;
        }
      )
    }

    
  }

  ngOnInit() {
    const user = localStorage.getItem("user_logado");
    this.userLogado = JSON.parse(user);

    if(this.userLogado.perfil == UserTypes.GESTOR){
      const {idSetor, setor} = this.userLogado;
      const {filters} = this.filtersOfConsult

      filters.setor = {
        id: idSetor,
        codigo: setor,
      }
    }

    if(this.userLogado.perfil !== 3){
      //this.getStates(this.userLogado.setor);
      this.debouncedGetSetor();
      this.setorFzs = this.userLogado.setor;
    }    

    if(this.userLogado.perfil == 1 || this.userLogado.perfil == 2){
      this.vetorSetor = {
        id: this.userLogado.idSetor,
        codigo: this.userLogado.setor,
      }
    }

    if(this.userLogado.perfil == 1){
      this.getVendedores();
    }    

  }

  getVendedores(){ 
    this.vendedorLoading = true;
    this.visitService.getVendedoresPorSetor(this.vetorSetor.codigo).subscribe(
      data => {
        this.lsVendedores = data;

        if (data.length == 1) {
          this.filtersOfConsult.filters.vendedor = data[0];
        }
        else {
          this.filtersOfConsult.filters.vendedor = null;
        }

        this.vendedorLoading = false;
    },
      error => console.log(error)
    );
  }

  getIdSetorComc(){
    if(this.vetorSetor){
      //this.filtersOfConsult.filters.CdFzs = this.vetorSetor.codigo;
      this.setorFzs = this.vetorSetor.codigo;
    }
    this.clientService.getIdSetor(this.setorFzs)
      .subscribe(
        data => {
          const idSetor: any = data;
          if(idSetor != 0){
            this.filtersOfConsult.filters.setor = idSetor;
            //this.getStates(idSetor);
            this.getVendedores();
          }else{
            toastr.error('Setor não encontrado')
          }

        },
        error => {
          console.log(error)
        }
      )
  }

  getStates(id: string) {
    this.clientService
      .getStates(id)
      .subscribe(data => {
        this.lsStates = data
      }, error => console.log(error));
  }

  ////retirar depois

  resetFilters(){
    const userPerfil = this.userLogado.perfil;

    if(userPerfil === UserTypes.GESTOR || userPerfil === UserTypes.VENDEDOR){
      this.filtersOfConsult.reset([
        'bairro',
        'cidade',
        'status',
        'uf',
        'vendedor'
      ])
    }else{
      this.filtersOfConsult.resetAll()
    }

    this.citiesRequest.reset()
    this.districtsRequest.reset()
  }

  onConsultar(){
    const params = this.getParams();

    if(!params) return;
    console.log(params);

    this.constultaRequest.get(
      this.clientService.getClientesPorVendedor(params)
    )
  }

  handleExport(){
    const params = this.getParams();

    if(!params) return;

    this.exportarClientesPorVendedor(params);
  }

  // Metodos Privados

  private getParams(){
    const {setor, vendedor, status, cidade, bairro, uf} = this.filtersOfConsult.filters;

    if(!setor){
      toastr.error('Setor Obrigatório')
      return null;
    }

    console.log(setor);

    const params: ParametrosClientesPorVendedor = {
      codigoRegional: this.vetorSetor.codigo,
    }
    
    if(vendedor) params.codigoSetor = vendedor.setor;
    if(uf) params.codigoUF = uf.idUf;
    if(status !== -1) params.status = status;
    if(cidade) params.codigoMunicipio = cidade.idMunic;
    if(bairro) params.bairro = bairro;

    console.log("params", params)

   return params;
  }

  onSetorChange(event){
    this.debouncedGetSetor()
  }

  private exportarClientesPorVendedor(params: ParametrosClientesPorVendedor){
    this.exportRequest.get(
      this.clientService.exportarClientesPorVendedor(params)
    ).subscribe(
      response => {
        Utilservice.exportToFile(
          response.blob(),
          `exportacao-carteira-clientes setor-${this.vetorSetor.codigo} ${moment().format('DD/MM/YYYY HH:mm:ss')}.xls`
        )
      }
    )
  }
}
